import { render } from "./InputTextArea.vue?vue&type=template&id=583f6a17"
import script from "./InputTextArea.vue?vue&type=script&lang=js"
export * from "./InputTextArea.vue?vue&type=script&lang=js"

import "./InputTextArea.vue?vue&type=style&index=0&id=583f6a17&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__